import React from "react";
import CustomSlider from "../CustomSlider";
import ConsentItem from "./ConsentItem";
import { useIntl } from "react-intl";
const RemoteConsentSlider = () => {
  const intl = useIntl();
  const sampleConsents = [
    {
      sampleImg: "/ui/images/Truman-UI-email-draft.svg",
      description: intl.formatMessage({
        id: "confirm-remote-consent.slide-1-description",
        defaultMessage: "The screens a sample of what the recipient will see",
      }),
    },
    {
      sampleImg: "/ui/images/Truman-UI-collect.svg",
      description: intl.formatMessage({
        id: "confirm-remote-consent.slide-1-description",
        defaultMessage: "The screens a sample of what the recipient will see",
      }),
    },
    {
      sampleImg: "/ui/images/Truman-UI-email-update.svg",
      description: intl.formatMessage({
        id: "confirm-remote-consent.slide-1-description",
        defaultMessage: "The screens a sample of what the  recipient will see",
      }),
    },
  ];
  return (
    <CustomSlider>
      {sampleConsents?.map((consent) => (
        <ConsentItem consent={consent} />
      ))}
    </CustomSlider>
  );
};

export default RemoteConsentSlider;
